import React from "react";
import AdminPostComments from "../components/AdminPostComments/AdminPostComments";

const AdminPostCommentsPage = () => {
  return <AdminPostComments />;
};

export default AdminPostCommentsPage;
